require('./cycle');
require('./helpers/page-visibility');
require('./helpers/request-animation-frame');
var cssVars = require('./helpers/css-vars');

$(document).ready(function() {
	var $keyvisualElements = $('.keyvisual__wrapper');
	// only keep keyvisualElements with more than one tab
	$keyvisualElements = $keyvisualElements.filter(function(_index, keyvisualElement) {
		return $(keyvisualElement).find('.keyvisual').length > 1;
	});

	$keyvisualElements.each(function(_index, keyvisualElement) {
		var $keyvisualElement = $(keyvisualElement);

		var $pager = $keyvisualElement.find('.keyvisual__navigation');

		$keyvisualElement.cycle({
			slides: '.keyvisual',
			slideClass: 'keyvisual',
			slideLeftClass: 'keyvisual--left',
			slideActiveClass: 'keyvisual--active',
			// next: $keyvisualElement.find('.keyvisual__next'),
			// prev: $keyvisualElement.find('.keyvisual__prev'),
			pager: $pager,
			pagerClass: 'keyvisual__link',
			pagerActiveClass: 'keyvisual__link--active',
			swipe: true
		});

		var cycle = $keyvisualElement.data('cycle');

		var slideTimer;

		function performTransition() {
			if (!Modernizr.mq('(min-width: ' + cssVars['size-sm'] + ')')) {
				// no auto-advance for mobile
				return;
			}
			cycle.API.next();
		}

		function gotoNextSlide() {
			clearTimeout(slideTimer);
			slideTimer = setTimeout(performTransition, 8000);
		}

		$keyvisualElement.on('cycle-after', gotoNextSlide);

		gotoNextSlide();

		var resizeTimer;
		$(window).on('resize.keyvisual', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(gotoNextSlide, 50);
		});

		$(document).on('page:visibilitychange', function(event, hidden) {
			if (hidden) {
				clearTimeout(slideTimer);
			} else {
				// restart timer
				gotoNextSlide();
			}
		});

		$pager.on('click', '.keyvisual__link', function() {
			$(this).blur();
		});
	});
});
